import SimuladorEconomia from "./SimuladorEconomiaVD";

export default function SimuladorVD() {
  return (
    <div
      id="simulador"
      className="w-full bg-gradient-to-br from-[#012334] to-[#00445A] px-4 md:px-8 lg:px-16 xl:px-40 py-12 md:py-16 lg:py-24 flex justify-center"
    >
      <div className="max-w-7xl w-full flex flex-col lg:flex-row justify-between items-start gap-8 lg:gap-16 xl:gap-32">
        <div className="flex-1 max-w-2xl lg:min-w-[520px] text-center lg:text-left">
          <h1 className="font-thin text-2xl md:text-3xl lg:text-4xl text-white !leading-normal mb-4">
            Parceria Thopen Energy + <br className="hidden lg:block" /> TIM:
            Economia de energia
          </h1>
          <p className="font-thin text-lg md:text-xl text-white leading-normal mb-4 opacity-90">
            Descubra a economia viável ao simular seu consumo de energia,
            optando pela energia limpa e renovável.
          </p>
        </div>

        <div className="flex-shrink-0 w-full lg:w-auto">
          <SimuladorEconomia />
        </div>
      </div>
    </div>
  );
}
